/**
 * @file 侧边栏目录配置
 * @author jiangjun
 */
export default [
    // {
    //     title: '首页',
    //     path: '/',
    //     icon: 'home'
    // },
    {
        title: '工作台',
        path: '/myProcessIndex',
        icon: 'approve',
        children: [{
            title: '我的流程',
            path: '/myProcess/myProcessIndex/myPedding',
            name: 'myProcessIndex',
            authName: 'workBreah',
            auth: ['myProcess'],
            actives: [
                '/myProcess/myProcessIndex/myStart',
                '/myProcess/myProcessIndex/myPedding',
                '/myProcess/myProcessIndex/myApprove'
            ],
        },
        {
            title: '流程查询',
            path: '/workbench/processQuery',
            name: 'processQuery',
            authName: 'workBreah',
            auth: ['processList']
        },
        ]
    },
    {
        title: '业务预算管理',
        path: '/businessBudget/budgetDetail',
        icon: 'budget',
        children: [
            {
                title: '业务预算明细',
                path: '/businessBudget/budgetDetail/budget',
                authName: 'businessBudget',
                auth: ['budgetDetail'],
                actives: [
                    '/businessBudget/budgetDetail/budget',
                    '/businessBudget/budgetDetail/execution',
                    '/businessBudget/budgetDetail/executionNonBusiness',
                    '/businessBudget/budgetDetail/loanBalance',
                ],
                children: [
                    {
                        title: '业务预算',
                        path: '/businessBudget/budgetDetail/budget',
                        // authName: 'businessBudget',
                        // auth: ['processList'],
                    },
                    {
                        title: '业务预算执行',
                        path: '/businessBudget/budgetDetail/execution',
                        // authName: 'businessBudget',
                        // auth: ['processList'],
                    },
                    {
                        title: '业务预算执行-非经营相关',
                        path: '/businessBudget/budgetDetail/executionNonBusiness',
                        // authName: 'businessBudget',
                        // auth: ['processList'],
                    },
                    {
                        title: '借款余额',
                        path: '/businessBudget/budgetDetail/loanBalance',
                        // authName: 'businessBudget',
                        // auth: ['processList'],
                    },
                ]
            },
            {
                title: '部门类型设置',
                path: '/businessBudget/departmentSelect',
                authName: 'businessBudget',
                auth: ['departmentSelect'],
            },
            {
                title: '归口人管理',
                path: '/businessBudget/personInCharge',
                authName: 'businessBudget',
                auth: ['personInCharge'],
            },
            {
                title: '借款余额同步管理',
                path: '/businessBudget/expenseName',
                authName: 'businessBudget',
                auth: ['expenseName'],
            },
            {
                title: '操作日志',
                path: '/businessBudget/operateLog',
                authName: 'businessBudget',
                auth: ['operateLog'],
            },
        ]
    },
    {
        title: '预算分析报表',
        path: '/budgetReport/summary',
        icon: 'customform',
        children: [
            {
                title: '总表',
                path: '/budgetReport/summary',
                authName: 'budgetReport',
                auth: ['summary'],
                name: 'budgetReportSummary',
            },
            {
                title: '分校按大类',
                path: '/budgetReport/SchoolByCategory',
                authName: 'budgetReport',
                auth: ['schoolByCategory'],
                name: 'budgetReportSchoolByCategory',
            },
            {
                title: '分校按明细',
                path: '/budgetReport/SchoolByDetail',
                authName: 'budgetReport',
                auth: ['schoolByDetail'],
                name: 'budgetReportSchoolByDetail',
            },
            {
                title: '总部职能按大类',
                path: '/budgetReport/HeadquarterByCategory',
                authName: 'budgetReport',
                auth: ['headquarterByCategory'],
                name: 'budgetReportHeadquarterByCategory',
            },
            {
                title: '总部职能按部门',
                path: '/budgetReport/HeadquarterByDept',
                authName: 'budgetReport',
                auth: ['headquarterByDept'],
                name: 'budgetReportHeadquarterByDept',
            },
            {
                title: '产品线',
                path: '/budgetReport/ProductLine',
                authName: 'budgetReport',
                auth: ['productLine'],
                name: 'budgetReportProductLine',
            },
            {
                title: '报告-按部门',
                path: '/budgetReport/ReportByDept',
                authName: 'budgetReport',
                auth: ['reportByDept'],
                name: 'budgetReportReportByDept',
            },
            {
                title: '报告-按归口',
                path: '/budgetReport/ReportByHost',
                authName: 'budgetReport',
                auth: ['reportByHost'],
                name: 'budgetReportReportByHost',
            },
            {
                title: '报告-按产品线',
                path: '/budgetReport/ReportByProductLine',
                authName: 'budgetReport',
                auth: ['reportByProductLine'],
                name: 'budgetReportReportByProductLine',
            },
        ]
    },

    // {
    //     title: '半年度管理',
    //     path: '/halfYearBudget',
    //     icon: 'year',
    //     children: [
    //         {
    //             title: '半年度明细查询',
    //             path: '/halfYearBudget/halfYearBudgetDetailList',
    //             name: 'halfYearBudgetDetailList',
    //             authName: 'halfyear',
    //             auth: ['list']
    //         },
    //     ],
    //     actives: [
    //     ]
    // },
    {
        title: '年度预算管理',
        path: '/yearBudgetHome',
        icon: 'year',
        children: [
            {
                title: '年度编制任务发起',
                path: '/yearBudgetHome/assignYearBudgetTask',
                name: 'assignYearBudgetTask',
                authName: 'year',
                auth: ['satrtBudget']
            },
            {
                title: '年度预算调整申请',
                path: '/yearBudgetHome/yearBudgetAdjust',
                name: 'yearBudgetAdjust',
                authName: 'year',
                auth: ['alterYearBudgetApply']
            },
            {
                title: '预算明细查询',
                path: '/yearBudgetHome/yearBudgetList',
                name: 'yearBudgetList',
                authName: 'year',
                auth: ['budgetDetailList'],
                actives: [
                    '/yearBudgetHome/yearBudgetList/execBudgetList',
                    '/yearBudgetHome/yearBudgetList/forzenBudgetList',
                ]
            },
            {
                title: '预算管控配置',
                path: '/yearBudgetHome/budgetControl',
                name: 'budgetControl',
                authName: 'year',
                auth: ['budgetControl'],
            },
            // {
            //     title: '年度预算调整列表',
            //     path: '/yearBudgetHome/yearBudgetAdjustList',
            //     name: 'yearBudgetAdjustList',
            //     authName: 'year',
            //     auth: ['list']
            // },
            // {
            //     title: '年度预算明细查询',
            //     path: '/yearBudgetHome/yearBudgetAdjustDetailList',
            //     name: 'yearBudgetAdjustDetailList',
            //     authName: 'year',
            //     auth: ['budgetDetailList']
            // },
        ]
    },
    // {
    //     title: '公司管理',
    //     path: '/company',
    //     icon: 'company',
    //     // authName: 'company',
    //     // auth: ['list'],
    //     name: 'company',
    // },
    {
        title: '会计科目管理',
        path: '/accountingTitle',
        icon: 'accountingTitle',
        authName: 'accountingTitle',
        auth: ['list'],
        name: 'accountingTitle',
    },
    {
        title: '实际数据管理',
        path: '/actualDataManage',
        icon: 'setting',
        children: [
            {
                title: '业绩考核数据管理',
                path: '/actualDataManage/performanceEvaluation',
                name: 'PerformanceEvaluation',
                authName: 'actualDataManage',
                auth: ['list']
            },
        ]
    },
    {
        title: '系统设置',
        path: '/setting',
        icon: 'setting',
        children: [
            {
                title: '用户管理',
                path: '/user',
                name: 'user',
                authName: 'system',
                auth: ['user']
            },
            {
                title: '角色管理',
                path: '/role',
                name: 'role',
                authName: 'system',
                auth: ['role']
            },
            {
                title: '菜单管理',
                path: '/menu',
                name: 'menu',
                authName: 'system',
                auth: ['menu']
            },
            // {
            //     title: '一级部门管理',
            //     path: '/firstDept',
            //     name: 'firstDept',
            // },
            // {
            //     title: '预算大类管理',
            //     path: '/budgetType',
            //     name: 'budgetType',
            // },
        ]
    }

]